var angular = require('angular');
var _module = require('./index');

require('../core/utils');
require('../events');
require('./contact-form');
require('./counterpart-info');

_module.directive('realtorSlide', [function() {
  return {
    restrict: 'E',
    templateUrl: 'js/components/modals/templates/realtor-slide.tmpl.html',
    scope: {
      report: "=",
      showFullscreenLoader: "=",
      hideFullscreenLoader: "=",
      options: "=",
      isMobile: "="
    },
    bindToController: true,
    controllerAs: 'vm',
    controller: [
      function() {
        var vm = this;
        
        vm.options = [
          { name:"I'd like to see this home" },
          { name: "I'm interested in buying a new home" },
          { name: "I'm interested in selling a home"},
          { name: 'Other' }
        ]
      }
    ]
  }
}]);
